"use strict";

/* ------------------------------------------------------------------ *
 * Mapper 180: UNROM variant (Crazy Climber)
 * ------------------------------------------------------------------ */
// UNROM variant (switchable bank at $C000)

function register(Mappers) {
  Mappers[180] = function (nes) {
    this.nes = nes;
  };

  Mappers[180].prototype = new Mappers[0]();

  Mappers[180].prototype.write = function (address, value) {
    if (address < 0x8000) {
      Mappers[0].prototype.write.apply(this, arguments);
      return;
    }

    // The switchable bank lives at $C000 and the first bank is fixed at $8000.
    this.loadRomBank(value & 0x0f, 0xc000);
  };

  Mappers[180].prototype.loadROM = function () {
    if (!this.nes.rom.valid) {
      throw new Error("Mapper 180: Invalid ROM! Unable to load.");
    }

    this.reset();
    this.loadCHRROM();
    this.loadBatteryRam();
    this.loadTrainer();
    this.loadRomBank(0, 0x8000);
    this.loadRomBank(this.nes.rom.romCount - 1, 0xc000);
    this.resetIrqHandler();
  };

  // Maps 25 and 193 are Color Dreams boards that some ROMs label differently.
}

module.exports = { register: register };
